import { message } from 'antd'
import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { RESPONSE_MESSAGE } from '../utils/constants'

// คำเรียกอื่นของวัสดุมาตรฐาน (green2get-app spec 111 · spec 017)

const FETCH_ALIAS_CANDIDATES_REQUEST =
  'materialAlias/FETCH_ALIAS_CANDIDATES_REQUEST'
const FETCH_ALIAS_CANDIDATES_SUCCESS =
  'materialAlias/FETCH_ALIAS_CANDIDATES_SUCCESS'
const FETCH_ALIAS_CANDIDATES_FAILURE =
  'materialAlias/FETCH_ALIAS_CANDIDATES_FAILURE'

const FETCH_SEARCH_MISS_REQUEST = 'materialAlias/FETCH_SEARCH_MISS_REQUEST'
const FETCH_SEARCH_MISS_SUCCESS = 'materialAlias/FETCH_SEARCH_MISS_SUCCESS'
const FETCH_SEARCH_MISS_FAILURE = 'materialAlias/FETCH_SEARCH_MISS_FAILURE'

export const ALIAS_STATUS = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
}

const emptyPage = { content: [], total: 0, page: 0, size: 20 }

// Initialize State
const initialState = {
  isCandidateLoading: false,
  isMissLoading: false,
  error: {},
  candidates: emptyPage,
  searchMiss: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALIAS_CANDIDATES_REQUEST:
      return {
        ...state,
        isCandidateLoading: true
      }
    case FETCH_ALIAS_CANDIDATES_SUCCESS:
      return {
        ...state,
        isCandidateLoading: false,
        candidates: action.payload
      }
    case FETCH_ALIAS_CANDIDATES_FAILURE:
      return {
        ...state,
        isCandidateLoading: false
      }
    case FETCH_SEARCH_MISS_REQUEST:
      return {
        ...state,
        isMissLoading: true
      }
    case FETCH_SEARCH_MISS_SUCCESS:
      return {
        ...state,
        isMissLoading: false,
        searchMiss: action.payload
      }
    case FETCH_SEARCH_MISS_FAILURE:
      return {
        ...state,
        isMissLoading: false
      }
    default:
      return state
  }
}

export const backendMessageOf = (error) =>
  (error.response && error.response.data && error.response.data.message) ||
  RESPONSE_MESSAGE.FAIL

export const getAliasCandidates = (page, size) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_ALIAS_CANDIDATES_REQUEST
      })

      const response = await API.get(`${EndPoints.MATERAIAL}/aliasCandidates`, {
        params: { page, size }
      })

      dispatch({
        type: FETCH_ALIAS_CANDIDATES_SUCCESS,
        payload: response.data.data || emptyPage
      })
    } catch (error) {
      message.error(backendMessageOf(error))
      dispatch({
        type: FETCH_ALIAS_CANDIDATES_FAILURE
      })
    }
  }
}

export const getSearchMiss = (from, to) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_SEARCH_MISS_REQUEST
      })

      const response = await API.get(`${EndPoints.MATERAIAL}/searchMiss`, {
        params: { from, to }
      })

      dispatch({
        type: FETCH_SEARCH_MISS_SUCCESS,
        payload: response.data.data || []
      })
    } catch (error) {
      message.error(backendMessageOf(error))
      dispatch({
        type: FETCH_SEARCH_MISS_FAILURE
      })
    }
  }
}

// คำเรียกอื่นของวัสดุหนึ่งตัว ใช้ในฟอร์มวัสดุ จึงคืนค่าให้ผู้เรียกแทนการเก็บใน store
export const getMaterialAlias = (materialId) => {
  return async () => {
    try {
      const response = await API.get(`${EndPoints.MATERAIAL}/alias`, {
        params: { materialId }
      })
      return response.data.data || []
    } catch (error) {
      message.error(backendMessageOf(error))
      return []
    }
  }
}

// คืน { success, message } ให้หน้าจอตัดสินเองว่าจะปิด modal หรือแสดงเหตุผลของ backend
export const saveMaterialAlias = (data) => {
  return async () => {
    try {
      await API.post(`${EndPoints.MATERAIAL}/alias`, data)
      return { success: true }
    } catch (error) {
      return { success: false, message: backendMessageOf(error) }
    }
  }
}

export const deleteMaterialAlias = (id) => {
  return async () => {
    try {
      await API.delete(`${EndPoints.MATERAIAL}/alias/${id}`)
      return { success: true }
    } catch (error) {
      return { success: false, message: backendMessageOf(error) }
    }
  }
}
